import { useLocales } from "@/locales";
import { CommonWrap, ComomonAlert } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { Trans } from "react-i18next";

export default function WebhookTransfer() {
  const { translate, currentLang } = useLocales();
  return (
    <ContentWrap
      showBorderBottom={false}
      leftChildrenSx={{
        paddingTop: "1px",
        paddingBottom: "32px",
      }}
      leftChildren={
        <CommonWrap>
          <>
            <Box
              id="transaction-statuses-in-webhook"
              component={"div"}
              className="title_0"
            >
              {translate("webhook_use.transfer_status_notifiy_title1")}
            </Box>
            <Box component={"div"} className="title_1">
              {translate("webhook_use.transfer_status_notifiy_title2")}
            </Box>

            {currentLang.value === "en" ? (
              <Box>
                <Box component={"div"} className="desc">
                  <Trans
                    i18nKey={"webhook_use.transfer_status_notifiy_list_desc1"}
                    t={translate as any}
                  >
                    s<strong>s</strong>
                  </Trans>
                </Box>
                <Box component={"div"} className="desc">
                  <Trans
                    i18nKey={"webhook_use.transfer_status_notifiy_list_desc2"}
                    t={translate as any}
                  >
                    s<strong>s</strong>
                  </Trans>
                </Box>
                <Box component={"div"} className="desc">
                  <Trans
                    i18nKey={"webhook_use.transfer_status_notifiy_list_desc3"}
                    t={translate as any}
                  >
                    s<strong>s</strong>
                  </Trans>
                </Box>
              </Box>
            ) : (
              <Box>
                {" "}
                <>
                  <Box component={"div"} className="desc">
                    {translate(
                      "webhook_use.transfer_status_notifiy_list_title1"
                    )}
                  </Box>

                  <Box
                    sx={{
                      ul: {
                        paddingLeft: "2em",
                      },
                      li: {
                        "::marker": {
                          textIndent: "2em",
                        },
                      },
                    }}
                  >
                    <ul>
                      <li>
                        <Box component={"div"} className="desc">
                          {translate(
                            "webhook_use.transfer_status_notifiy_list_title1_desc1"
                          )}
                        </Box>
                      </li>
                      <li>
                        <Box component={"div"} className="desc">
                          {translate(
                            "webhook_use.transfer_status_notifiy_list_title1_desc2"
                          )}
                        </Box>
                      </li>
                    </ul>
                  </Box>
                </>
                <>
                  <Box component={"div"} className="desc">
                    {translate(
                      "webhook_use.transfer_status_notifiy_list_title2"
                    )}
                  </Box>

                  <Box
                    sx={{
                      ul: {
                        paddingLeft: "2em",
                      },
                      li: {
                        "::marker": {
                          textIndent: "2em",
                        },
                      },
                    }}
                  >
                    <ul>
                      <li>
                        <Box component={"div"} className="desc">
                          {translate(
                            "webhook_use.transfer_status_notifiy_list_title2_desc1"
                          )}
                        </Box>
                      </li>
                      <li>
                        <Box component={"div"} className="desc">
                          {translate(
                            "webhook_use.transfer_status_notifiy_list_title2_desc2"
                          )}
                        </Box>
                      </li>
                    </ul>
                  </Box>
                </>
                <>
                  <Box component={"div"} className="desc">
                    {translate(
                      "webhook_use.transfer_status_notifiy_list_title3"
                    )}
                  </Box>

                  <Box
                    sx={{
                      ul: {
                        paddingLeft: "2em",
                      },
                      li: {
                        "::marker": {
                          textIndent: "2em",
                        },
                      },
                    }}
                  >
                    <ul>
                      <li>
                        <Box component={"div"} className="desc">
                          {translate(
                            "webhook_use.transfer_status_notifiy_list_title3_desc1"
                          )}
                        </Box>
                      </li>
                      <li>
                        <Box component={"div"} className="desc">
                          {translate(
                            "webhook_use.transfer_status_notifiy_list_title3_desc2"
                          )}
                        </Box>
                      </li>
                    </ul>
                  </Box>
                </>
              </Box>
            )}

            <ComomonAlert>
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"webhook_use.transfer_status_notifiy_tip_desc"}
                  t={translate as any}
                >
                  Just a placeholder
                  <strong>Just a placeholder</strong>
                </Trans>
              ) : (
                <div
                  className="code"
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "webhook_use.transfer_status_notifiy_tip_desc"
                    ) as any,
                  }}
                />
              )}
            </ComomonAlert>
          </>
        </CommonWrap>
      }
    />
  );
}
